import Formatter from 'src/class/Formatter';
import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
          prop: 'date_save',
          label: i18n.t('common_words.date'),
          align: 'center',
          fixed: true,
          minWidth: 100,
        },
        {
          prop: 'farm',
          label: i18n.t('common_words.farm'),
          align: 'left',
          fixed: true,
          minWidth: 160,
        },
        {
          prop: 'worker',
          label: i18n.t('labor.worker'),
          fixed: true,
          minWidth: 220,
        },
        {
          prop: 'quantity',
          label: i18n.t('common_words.quantity'),
          align: 'center',
          minWidth: 100,
        },
        {
          prop: 'total_profit',
          label: i18n.t('grow.total_profit'),
          align: 'center',
          minWidth: 100,
            formatter: (row, column) => {
              return `$${Formatter.formatNumber(Number(row[column.property]))}`;
            },
        }
    ];
    const Search = { ...Tables.Search };
    return { Table, Search };
};

export default configTable;